import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function FeaturedComic() {
  const featuredComic = comics[0];

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill"></i>
            </div>
            编辑精选
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            今日推荐
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row gap-6 md:gap-8 items-center bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
          <Link
            to={`/article/${featuredComic.id}`}
            className="flex-shrink-0 w-48 md:w-56 cursor-pointer"
          >
            <div className="aspect-[3/4] rounded-xl overflow-hidden">
              <img
                src={featuredComic.cover}
                alt={featuredComic.title}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                title={`${featuredComic.title} - 布丁漫画网`}
              />
            </div>
          </Link>
          <div className="flex-1 text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-3">
              <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                连载中
              </span>
              {featuredComic.tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              <Link to={`/article/${featuredComic.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                {featuredComic.title}
              </Link>
            </h3>
            <p className="text-xs text-foreground-500 mb-4">
              作者：{featuredComic.author} &nbsp;|&nbsp; 评分：{featuredComic.rating} &nbsp;|&nbsp; 阅读量：{(featuredComic.views / 10000).toFixed(0)}万
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 line-clamp-3">
              {featuredComic.description}
            </p>
            <Link
              to={`/article/${featuredComic.id}`}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}